// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sidebarQuestionBlock":"_2g0cs4","ctaButton":"_1x1736","heading":"_2yHYhi","textWrapper":"YR3Ydy","textBlock":"_9biQK1","avatarWrapper":"_3FEatD"};